<template>
	<div class="pagecontent">
		 <div class="topimg">
			 <img :src="topImg.bgImg"/>
		 </div>
		 <div class="content">
			 <div class="special">
				 <div class="margin-first conser">
				 	<div class="conser-img "><img :src="images.con1" /></div>
				 	<div class="conser-text">
				 		<p class="conser-title">搜索引擎优化</p>
				 		<p class="conser-tcon">
				 			快捷SEO设置，提升网站搜索引擎权重和排名
				 		</p>
				 	</div>
				 </div>
				 <div class="conser margin-all">
				 	<div class="conser-img"><img :src="images.con2" /></div>
				 	<div class="conser-text">
				 		<p class="conser-title">模块化组件</p>
				 		<p class="conser-tcon">
				 			标准化模块，搭建更高效快捷
				 		</p>
				 	</div>
				 </div>
				 <div class="conser margin-all">
				 	<div class="conser-img"><img :src="images.con3" /></div>
				 	<div class="conser-text">
				 		<p class="conser-title">多样化模板</p>
				 		<p class="conser-tcon">
				 			多种模板选择，满足不同场景
				 		</p>
				 	</div>
				 </div>
				 <div class="conser margin-all">
				 	<div class="conser-img"><img :src="images.con4" /></div>
				 	<div class="conser-text">
				 		<p class="conser-title">服务专业化</p>
				 		<p class="conser-tcon">
				 			提供建站+空间+域名+备案一站式服务
				 		</p>
				 	</div>
				 </div>
			 </div>
			 <div class="moremodel">
				 <h1>海量模板</h1>
				 <p>可视化自由设计，个性化定制，随意选择</p>
				
				<div class="modelimg">
					<img class="" :src="modelbgimg.img1" />
					<img class="margin-all" :src="modelbgimg.img2" />
					<img class="margin-all" :src="modelbgimg.img3" />
				</div>
				<div class="modelimg">
					<img class="" :src="modelbgimg.img4" />
					<img class="margin-all" :src="modelbgimg.img5" />
					<img class="margin-all" :src="modelbgimg.img6" />
				</div>
				<div class="modelbutton">
					<router-link :to="tourl" tag="div">
						<input type="button" value="查看更多>>" />
					</router-link>
				</div>
			 </div>
			 <div class="show-price">
				 <h1>套餐介绍</h1>
				 <div class="pricetitle">
					 <img :src='pricetitleimg' />
				 </div>
				 <div class="priceintro">
					 <h1>套餐价格</h1>
					  <img :src='priceintroimg' />
				 </div>
			 </div>
		 </div>
		 
		 <div class="el-footer">
		   <Footer />
		 </div>
	</div>
	
</template>

<script>
	import TopImg from '../components/TopImg'
	import Footer from '../components/Footer.vue'
	export default{
		name: '',
		components: { TopImg, Footer },
		props: {},
		data() {
			 return {
				 tourl:'webmodel',
				 topImg: {
				   title: '',
				   bgImg: require('../assets/images/webpagetop.png'),
				   content: '',
				   bl: false,
				   indexId: 11,
				 },
				 images:{
					 con1:require('../assets/images/webpage/serch.jpg'),
					 con2:require('../assets/images/webpage/mokuai.jpg'),
					 con3:require('../assets/images/webpage/moremodel.jpg'),
					 con4:require('../assets/images/webpage/serve.jpg')
				 },
				 modelbgimg:{
					 img1:require('../assets/images/webpage/model1.png'),
					 img2:require('../assets/images/webpage/model2.png'),
					 img3:require('../assets/images/webpage/model3.png'),
					 img4:require('../assets/images/webpage/model4.png'),
					 img5:require('../assets/images/webpage/model5.png'),
					 img6:require('../assets/images/webpage/model6.png')
				 },
				 pricetitleimg:require("../assets/images/webpage/pricetitle.png"),
				 priceintroimg:require("../assets/images/webpage/priceintro.png")
			 }
		}
	}
</script>

<style>
	.pagecontent{background: #E9EBEC;}
	.special{width:80%;margin:0 auto;height:360px;background: #E9EBEC;padding: 20px 10px 20px 10px;}
	.topimg img{width: 100%;}
	.margin-first{margin-left:2%;;}
	.margin-all{margin-left: 2%;}
	.conser{width: 23%;height:310px;background: #ffffff;border-radius: 8px;text-align: center;float: left;}
	.conser img{width:100%;border-radius: 8px;}
	.conser-title{font-size: 22px;font-weight: 600;}
	.el-footer{float: none;clear: both;}
	.conser-tcon{font-size: 16px;}
	.moremodel{width: 100%;background-image:url('../assets/images/webpage/modelbg.png');height: 800px;text-align: center;}
	.moremodel h1{padding-top: 10px;color: #ffffff;}
	.moremodel p{color: #ffffff;font-size: 16px;}
	.modelimg{width: 80%;margin:0 auto;padding: 10px;}
	.modelimg img{padding: 10px;background: #ffffff;border-radius: 8px;width:30%;}
	.modelbutton input{background: none;border: 1px solid #000;padding: 10px;color: #ffffff;font-size: 16px;width: 160px;height: 45px;margin-top: 10px;}
	.modelbutton input:hover{background-color: #3D9BE9;cursor: pointer;border: none;}
	.show-price{width: 100%;background:#F5F5F7 ;text-align: center;}
	.show-price img{width: 60%;}
	.priceintro {width: 100%;background: #ffffff;text-align: center;}
	.priceintro h1{padding-top: 10px;}
	.priceintro img{width: 60%;margin:0 auto;padding: 15px;}
</style>